import { onActivated as i, onDeactivated as c } from "vue";
function s(a) {
  const e = { isDeactivated: !1 };
  let t = !1;
  return i(() => {
    if (e.isDeactivated = !1, !t) {
      t = !0;
      return;
    }
    a();
  }), c(() => {
    e.isDeactivated = !0, t || (t = !0);
  }), e;
}
export {
  s as useReactivated
};
